import { Component } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import { server } from "../../connection/config";
import { setHostGrant } from "../../connection/host-auth";

import "./HostLoginModal.css";

class HostLoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            error: null,
            loading: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCodeChange = this.handleCodeChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    handleCodeChange(event) {
        this.setState({ code: event.target.value, error: null });
    }

    handleKeyPress(event) {
        if (event.key === "Enter" && this.state.code.trim()) {
            this.handleSubmit();
        }
    }

    async handleSubmit() {
        const { code } = this.state;

        if (!code.trim()) {
            this.setState({ error: "Please enter an access code" });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(`${server}/api/host/auth`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ code: code.trim() })
            });

            if (response.ok) {
                const { hostGrant, expiresAt, role } = await response.json();
                setHostGrant(hostGrant, expiresAt, role);
                this.setState({ loading: false, code: "" });
                this.props.onSuccess(role);
            } else {
                this.setState({
                    loading: false,
                    error: "Invalid access code. Please try again."
                });
            }
        } catch (e) {
            console.error("Host auth error:", e);
            this.setState({
                loading: false,
                error: "Connection error. Please try again."
            });
        }
    }

    render() {
        const { show, onClose } = this.props;
        const { code, error, loading } = this.state;

        return (
            <Modal show={show} onHide={onClose} centered className="host-login-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Host Access</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted mb-3">
                        Enter the host access code to unlock hosting tools.
                    </p>

                    {error && (
                        <Alert variant="danger" className="mb-3">
                            {error}
                        </Alert>
                    )}

                    <Form.Group>
                        <Form.Control
                            type="password"
                            placeholder="Access code"
                            value={code}
                            onChange={this.handleCodeChange}
                            onKeyPress={this.handleKeyPress}
                            disabled={loading}
                            autoFocus
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        variant="warning"
                        onClick={this.handleSubmit}
                        disabled={loading || !code.trim()}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Verifying...
                            </>
                        ) : (
                            "Unlock"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default HostLoginModal;
